export interface ReportingPeriod {
  month: number;
  year: number;
  businessTypeId: string;
}

// Returns the list of report periods sorted by newest to oldest
export const getSortedReportingPeriods = (reportingPeriods: ReportingPeriod[]): ReportingPeriod[] => {
  return reportingPeriods.sort((a, b) => {
    if (a.year === b.year) {
      return b.month - a.month;
    }
    return b.year - a.year;
  });
}
